import { create } from 'zustand'

const useAlertStore = create(set => ({
  alert: false,
  setAlert: alert => set({ alert }),
}))

export { useAlertStore }
